import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useGetShippingMethods } from '@grandvisionhq/shipping';

const useShippingMethodsList = (onShippingMethodsLoadCompleted, onError)=>{
    const { cart  } = Context.useCart();
    /**
   *  Error handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadError = (errorResponse)=>{
        console.error(`query:[shippingMethodForCart]: unable to load shipping methods`, errorResponse);
        onError === null || onError === void 0 ? void 0 : onError('MUTATION');
    };
    const [loadShippingMethods, { called , data: shippingMethodList , loading , error  }] = useGetShippingMethods({
        onError: onShippingMethodsLoadError,
        onCompleted: onShippingMethodsLoadCompleted
    });
    /**
   *  Load shipping methods cart id updated
   */ React.useEffect(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.id) && !called) {
            loadShippingMethods(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice);
        }
    }, [
        loadShippingMethods,
        called,
        cart
    ]);
    const reloadShippingMethods = React.useCallback(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.id) && !called) {
            loadShippingMethods(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice);
        }
    }, [
        called,
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice,
        loadShippingMethods
    ]);
    return {
        shippingMethodList,
        reloadShippingMethods,
        isLoading: loading,
        error,
        called
    };
};

export { useShippingMethodsList };
//# sourceMappingURL=use-shipping-methods-list.js.map
